import { startOfWeek, subWeeks } from 'date-fns'
import { getUserWeekStartsOn } from '~/helpers/dateHelper'
import { useMemo } from 'react'

import { AnalyticsQueryFilter } from '@hap/analytics'
import { Timespan } from '@hap/utils'

import { MetricFilters } from './metric-widget'

export function useAnalyticsPresets(props: {
  filters: MetricFilters
  criteriaId?: string
  timespan?: Timespan.StaticTimespan
  baseFilters?: AnalyticsQueryFilter[]
}): {
  filters: AnalyticsQueryFilter[]
  trendFilters: AnalyticsQueryFilter[]
  hasFilter: boolean
  timespan: {
    start: Date
    end: Date
  }
} {
  const filters =
    props.baseFilters ||
    ([
      {
        field: 'publishedAt',
        op: 'isNotNull',
        dataset: 'evaluations',
      },
    ] satisfies AnalyticsQueryFilter[])
  const trendFilters: AnalyticsQueryFilter[] = [...filters]
  let hasFilter = false
  if (props.filters) {
    if (props.filters.workspaceIds) {
      hasFilter = true
      filters.push({
        field: 'workspaceId',
        ...props.filters.workspaceIds,
        dataset: 'interactions',
      })
      trendFilters.push({
        field: 'workspaceId',
        ...props.filters.workspaceIds,
        dataset: 'interactions',
        op: 'nin',
      })
    }
    if (props.filters.channelIds) {
      hasFilter = true
      filters.push({
        field: 'channelId',
        ...props.filters.channelIds,
        dataset: 'interactions',
      })
      trendFilters.push({
        field: 'channelId',
        ...props.filters.channelIds,
        dataset: 'interactions',
        op: 'nin',
      })
    }
    if (props.filters.groupIds) {
      hasFilter = true
      filters.push({
        field: 'groupIds',
        ...props.filters.groupIds,
        dataset: 'interactions',
      })
      trendFilters.push({
        field: 'groupIds',
        ...props.filters.groupIds,
        dataset: 'interactions',
        op: 'nin',
      })
    }
    if (props.filters.reportToIds) {
      hasFilter = true
      filters.push({
        field: 'assignedSupervisorId',
        ...props.filters.reportToIds,
        dataset: 'interactions',
      })
      trendFilters.push({
        field: 'assignedSupervisorId',
        ...props.filters.reportToIds,
        dataset: 'interactions',
        op: 'nin',
      })
    }
    if (props.filters.handledBy) {
      hasFilter = true
      filters.push({
        field: 'handledBy',
        ...props.filters.handledBy,
        dataset: 'interactions',
      })
      trendFilters.push({
        field: 'handledBy',
        ...props.filters.handledBy,
        dataset: 'interactions',
        op: 'nin',
      })
    }
    if (props.filters.assignedTo) {
      hasFilter = true
      filters.push({
        field: 'assignedTo',
        ...props.filters.assignedTo,
        // dataset: 'evaluationCriteriaScores',
      })
      trendFilters.push({
        field: 'assignedTo',
        ...props.filters.assignedTo,
        // dataset: 'evaluationCriteriaScores',
        op: 'nin',
      })
    }
    if (props.filters.scorecardIds) {
      hasFilter = true
      filters.push({
        field: 'scorecardId',
        ...props.filters.scorecardIds,
        dataset: 'evaluations',
      })
      trendFilters.push({
        field: 'scorecardId',
        ...props.filters.scorecardIds,
        dataset: 'evaluations',
      })
    }
    if (props.filters.reviewed) {
      hasFilter = true
      filters.push({
        field: 'reviewedAt',
        ...props.filters.reviewed,
        dataset: 'evaluations',
      })
    }
  }

  // if (props.scorecardId) {
  //   filters.push({
  //     field: 'scorecardId',
  //     op: 'eq',
  //     value: props.scorecardId,
  //     dataset: 'evaluations',
  //   })
  // }

  if (props.criteriaId) {
    filters.push({
      field: 'scorecardCriteriaId',
      op: 'eq',
      value: props.criteriaId,
      dataset: 'evaluationCriteriaScores',
    })
  }

  const defaultTimespan = useMemo(() => getDefaultTimespan(), [])
  const timespan = props.timespan ?? defaultTimespan

  return {
    filters,
    trendFilters,
    hasFilter,
    timespan,
  }
}

const getDefaultTimespan = () => ({
  start: startOfWeek(subWeeks(new Date(), 4), { weekStartsOn: getUserWeekStartsOn() }),
  end: new Date(),
})
